/**
 * First-run setup wizard (ADR-0073 dec. 4, post-boot half).
 * Backend router: backend/src/hub/admin/routes/setup.py (paths relative to /api/admin).
 *
 * `pending` is DERIVED from the initial admin still holding the default password
 * (self-latching — changing the password auto-dismisses the wizard). `recovery`
 * discloses the vault key + DB URL (settings:write, audited).
 */
import { api } from "./api";

export interface SetupStatus {
  pending: boolean;
  default_password: boolean;
  admin_username: string;
  licensed: boolean;
  enforced: boolean;
}

export interface RecoveryConfig {
  vault_key: string;
  database_url: string;
}

export const setupApi = {
  status: () => api.get<SetupStatus>("/setup/status"),
  recovery: () => api.get<RecoveryConfig>("/setup/recovery"),
};
